import * as yup from 'yup';

const validationSchema = yup.object({
  fullName: yup
    .string()
    .trim()
    .matches(/^[a-zA-Z ]{2,40}$/)
    .min(3, 'Please enter a valid name')
    .max(50, 'Please enter a valid name')
    .required('Please specify your full name'),
  birthPlace: yup
    .string()
    .trim()
    .min(3, 'Please enter a valid name')
    .max(50, 'Please enter a valid name')
    .required('Please specify your birth place'),

  aadhar: yup
    .string()
    .trim()
    .matches(
      /^[2-9]{1}[0-9]{3}\s{1}[0-9]{4}\s{1}[0-9]{4}$/),
    

  dateOfBirth: yup
    .string()
    .typeError('Not a valid  date. Example: DD-MM-YYYY')
    .max(10, 'Not a valid  date. Example: DD-MM-YYYY')
    .matches(/^([0-9]{2})-([0-9]{2})-([0-9]{4})$/)
    .required('Not a valid  date. Example: DD-MM-YYYY'),
});

export default validationSchema;
